<template>
  <vcl-facebook v-if="loading"></vcl-facebook>
  <div v-else-if="!loading && result && result.id">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card class="text-center" style="font-size:1.3em">
          <b-row>
            <b-col md="12">
              <h1> {{result.fqdn}} </h1>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>合計ページ数 <br><small>(ページ＋外部＋リソース)</small> </label><br>
                <label for="ph_page">{{ result.page_count | number }} ナンバー</label>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>検査時間</label>
                <br>
                (
                <b-badge variant="primary">
                  合計 : {{moment(result.finished_at).diff(result.started_at, 'minutes') == 0 ? "< 1" : moment(result.finished_at).diff(result.started_at, 'minutes')}} min
                </b-badge>
                )
                <p>{{result.started_at | datetime}} ~ {{result.finished_at | datetime}}</p>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_detect_count" v-b-tooltip.hover>検出ページ</label><br>
                <b-badge variant="danger" v-if="result.detect_count > 0"> {{result.detect_count}} 数字 </b-badge>
                <span v-else>-</span>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>ステータス</label><br>
                <b-badge v-if="result.finished_at" :variant="result.finished_at ? 'info' : 'light'"> {{result.finished_at ? 'Finished' : 'Scanning'}} </b-badge>
                <b-badge v-if="result.error_count > 0" variant="warning"> {{result.error_count ? 'Error' : 'Scanning'}} </b-badge>
                <br>
                <b-badge v-if="result.is_js" variant="info"> JSイベント</b-badge>
                <div v-if="result.is_login">
                  <b-badge variant="info"> ログイン中</b-badge>
                  <b-badge v-if="result.is_login_success" variant="success"> ログイン成功</b-badge>
                  <b-badge v-else variant="warning"> ログイン失敗</b-badge>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <hr v-if="result.policy">
          <b-row v-if="result.policy">
            <b-col>
              <b-form-group>
                <label for="ph_links" v-b-tooltip.hover title="ページ内を移動するためのサブリンクの最大数を入力します。 余分なリンクは無視してください。 通常、1 つのページに存在するリンクが多すぎる場合は、バランスの取れた方法でチェックされないことを防ぐために、他のページに移動する前に最大のナビゲーション ページに到達することができます。 1～1,000の範囲で指定できます。">サブページリンク
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" class="w-100 text-center" id="ph_depth" v-model="result.policy.depth" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <label for="ph_limit" v-b-tooltip.hover title="検査サイトで確認する総ページ数。 入力した数値に達したらチェックを終了します。 1からライセンス制限までの範囲で指定できます。">最大ナビゲーションページ
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" class="w-100 text-center" id="ph_links" v-model="result.policy.links" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <label for="ph_depth" v-b-tooltip.hover title="最初のページから次のページへリンクを移動（パス）して確認するかどうかを入力します。 1～100の範囲で指定できます。">最大パス深度
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" class="w-100 text-center" id="ph_limit" v-model="result.policy.limit" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <label for="ph_timeout" v-b-tooltip.hover title="ページの読み込みを待つ時間。 1～30の範囲で指定できます。">タイムアウト(秒)
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" class="w-100 text-center" id="ph_timeout" v-model="result.policy.timeout" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <label for="ph_delay" v-b-tooltip.hover title="新しいページに移動するまでの待ち時間。 1～10,000の範囲で指定できます。">チェック速度(ミリ秒)
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" class="w-100 text-center" id="ph_delay" v-model="result.policy.delay" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="4" class="animated fadeIn fadeOut">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>スクリーンショット</label><br>
                <img class="border" :src="image" :style="{ width: thumbnail_size }">
              </b-form-group>
            </b-col>
            <b-col md="4" class="animated fadeIn fadeOut mt-2">
              <center>
                <label for="ph_count" v-b-tooltip.hover>サイトチェックの概要</label><br>
                <vue-apex-charts class="mt-5" ref="_list" :width="thumbnail_size" type="donut" :options="options_site" :series="data_site"></vue-apex-charts>
              </center>
            </b-col>
            <b-col md="4" class="animated fadeIn fadeOut mt-2">
              <center>
                <label for="ph_count" v-b-tooltip.hover>リソースの割合</label><br>
                <vue-apex-charts class="mt-5" ref="_list" :width="thumbnail_size" type="donut" :options="options_resource" :series="data_resource"></vue-apex-charts>
              </center>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>検出リスト</strong> <small>検出パターン一覧 {{result.detect_count | number}} ナンバー ({{result.detect.start+(result.detect_count ? 1: 0)}} ~ {{result.detect.end | number}})</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.detect_count === 0"><template><div>データ無し</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll('detect')" ref="detect_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.detect.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
              <strong v-b-tooltip.hover title="エラーページを装って悪意のあるコードが配布される可能性がある 認識されたエラーページを確認する">
                エラーページ
                <span class="text-info">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
              <small>一覧ページ {{result.error_count || 0 | number}} 개 ({{result.error.start+(result.error_count ? 1 : 0)}} ~ {{result.error.end | number}})</small>
              <small v-if="result.error_count != result.error.end" class="pull-right">スクロールダウン時の表示数を増やす</small>
            </div>
            <b-row>
              <b-col md="12">
                <pre v-if="result.error_count === 0"><template><div>データ無し</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" ref="error_list">
                <pre v-if="error_list.length" slot="body" style="width: 3000px; overflow: visible;">{{result.error.data}}</pre>
                <pre v-else slot="body">
                  <template><div>データ無し</div></template>
                </pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <strong>ページ一覧</strong>
            <small>ページ一覧 {{result.page_count || 0 | number}} Numbers ({{result.page.start+(result.page_count ? 1 : 0)}} ~ {{result.page.end | number}})</small>
            <small v-if="result.page_count != result.page.end" class="pull-right">スクロールダウン時の表示数を増やす</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.page_count === 0"><template><div>データ無し</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll('page')" ref="page_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.page.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>外部ページ</strong>
            <small>外部サイト訪問一覧 {{result.ext_count | number}} Number ({{result.ext.start+(result.ext_count ? 1 : 0)}} ~ {{result.ext.end | number}})</small>
            <small v-if="result.ext_count != result.ext.end" class="pull-right">スクロールダウン時の表示数を増やす</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.ext_count === 0"><template><div>データ無し</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll('ext')" ref="ext_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.ext.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>リソースデータ</strong>
            <small>リソースデータ一覧 {{result.resource_count | number}} Numbers ({{result.resource.start+(result.resource_count ? +1 : 0)}} ~ {{result.resource.end | number}})</small>
            <small v-if="result.resource_count != result.resource.end" class="pull-right">スクロールダウン時の表示数を増やす</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.resource_count === 0"><template><div>データ無し</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll('resource')" ref="resource_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.resource.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
